import { FaArrowLeft } from "react-icons/fa";
import { useTranslation } from "react-i18next";
import SectionHeader from "../common/SectionHeader";
import { acfList, acfText } from "../../utils/landingAcf";
import {
  LANDING_WHATSAPP_CONTEXT,
  resolveLandingWhatsAppCta,
} from "../../utils/landingWhatsapp";
import { SECTION_CONTAINER } from "../../utils/layout";
import LandingSection from "./LandingSection";
import ScrollReveal, { revealItemProps } from "./ScrollReveal";
import SectionLoader from "../common/SectionLoader";
import "../common/HeroSection.css";
import "./LandingSections.css";

function LandingQuality({ acf, loading = false }) {
  const { t } = useTranslation();

  if (loading) {
    return (
      <LandingSection className="landing-quality">
        <SectionLoader size="md" label={t("Loading section")} />
      </LandingSection>
    );
  }

  const title = acfText(acf.quality_title);
  const description = acfText(acf.quality_description);
  const ctaText = acfText(acf.quality_cta_text);
  const ctaLink = resolveLandingWhatsAppCta(t, LANDING_WHATSAPP_CONTEXT.QUALITY);
  const features = acfList(acf, "quality_feature_");

  if (!title && !description && features.length === 0 && !ctaText) return null;

  return (
    <LandingSection className="landing-quality">
      <div className={`${SECTION_CONTAINER} landing-quality__split`}>
        <ScrollReveal className="landing-quality__content" variant="up">
          {title || description ? (
            <SectionHeader
              title={title || undefined}
              subtitle={description || undefined}
              showAccent
              centered
              titleId="landing-quality-title"
              containerClass=""
            />
          ) : null}

          {ctaText ? (
            <a
              href={ctaLink.href}
              className="hero-btn hero-btn--primary landing-quality__cta"
              target={ctaLink.target}
              rel={ctaLink.rel}
            >
              <span className="hero-btn__label">{ctaText}</span>
              <span className="hero-btn__icon-wrap" aria-hidden="true">
                <FaArrowLeft className="hero-btn__icon" />
              </span>
            </a>
          ) : null}
        </ScrollReveal>

        {features.length > 0 ? (
          <ScrollReveal
            as="ul"
            className="landing-quality__list"
            stagger
            aria-labelledby={title ? "landing-quality-title" : undefined}
          >
            {features.map((feature, index) => (
              <li
                key={feature}
                {...revealItemProps(index, "landing-quality__list-item")}
              >
                <p className="landing-quality__list-text">{feature}</p>
              </li>
            ))}
          </ScrollReveal>
        ) : null}
      </div>
    </LandingSection>
  );
}

export default LandingQuality;
